/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/lines-between-class-members */
/* eslint-disable class-methods-use-this */
import { Box } from '@chakra-ui/react';
import * as React from 'react';
import {
  CellTemplate,
  Cell,
  Compatible,
  Uncertain,
  getCellProperty,
  isAlphaNumericKey,
  keyCodes,
  UncertainCompatible,
  getCharFromKeyCode,
  isNavigationKey,
} from '@silevis/reactgrid';

import formatValue from 'utils/FormatValues';

export interface FlagCell extends Cell {
  type: 'flag';
  text: string;
  rowId: string;
}
export class NewCell implements CellTemplate<FlagCell> {
  getCompatibleCell(uncertainCell: Uncertain<FlagCell>): Compatible<FlagCell> {
    const text = getCellProperty(uncertainCell, 'text', 'string');
    const value = Number.parseFloat(`${text}`);
    return { ...uncertainCell, text, value } as Compatible<FlagCell>;
  }

  getClassName(cell: any) {
    const isValid = cell.validator ? cell.validator(cell.text) : true;
    const className = cell.className ?? '';
    return `${isValid ? 'valid' : 'invalid'} ${
      cell.placeholder && cell.text === '' ? 'placeholder' : ''
    } ${className}`;
  }

  isFocusable?(cell: Compatible<FlagCell>): boolean {
    return !cell?.nonEditable;
  }

  handleKeyDown(
    cell: Compatible<any>,
    keyCode: number,
    ctrl: boolean,
    shift: boolean,
    alt: boolean,
  ): { cell: any; enableEditMode: boolean } {
    const char = getCharFromKeyCode(keyCode, shift);
    if (!ctrl && !alt && isAlphaNumericKey(keyCode) && !(shift && keyCode === keyCodes.SPACE))
      return {
        cell: this.getCompatibleCell({ ...cell, text: shift ? char : char.toLowerCase() }),
        enableEditMode: true,
      };
    return { cell, enableEditMode: keyCode === keyCodes.POINTER || keyCode === keyCodes.ENTER };
  }

  update(
    cell: Compatible<FlagCell>,
    cellToMerge: UncertainCompatible<FlagCell>,
  ): Compatible<FlagCell> {
    return this.getCompatibleCell({
      ...cell,
      text: cellToMerge.text,
    });
  }

  render(
    cell: any,
    isInEditMode: boolean,
    onCellChanged: (cell: Compatible<FlagCell>, commit: boolean) => void,
  ) {
    const formattedValue = formatValue(
      cell?.isPercentage ? +cell?.text * 100 : +cell?.text,
      cell?.format,
    );

    if (isInEditMode) {
      return (
        <input
          type='number'
          style={{
            fontSize: '15px',
            fontWeight: '400',
            fontFamily: 'Roboto Regular',
            lineHeight: '18px',
            textAlign: 'center',
            overflowY: 'hidden',
          }}
          ref={(input) => {
            input && input.focus();
          }}
          placeholder='Enter text'
          defaultValue={cell?.isPercentage ? +cell?.text * 100 : +cell?.text}
          onChange={(data: any) => {
            return onCellChanged(
              this.getCompatibleCell({ ...cell, text: data.target.value }),
              false,
            );
          }}
          onCopy={(e) => e.stopPropagation()}
          onCut={(e) => e.stopPropagation()}
          onPaste={(e) => e.preventDefault()}
          onPointerDown={(e) => e.stopPropagation()}
          onKeyDown={(e) => {
            if (isAlphaNumericKey(e.keyCode) || isNavigationKey(e.keyCode)) {
              e.stopPropagation();
            }

            if (e.keyCode === keyCodes.ENTER) {
              e.stopPropagation();
              onCellChanged(
                this.getCompatibleCell({
                  ...cell,
                  text: cell?.isPercentage ? `${+e.target.value / 100}` : e.target.value,
                }),
                true,
              );
            }
          }}
        />
      );
    }

    return (
      <>
        {!cell?.nonEditable && cell.show === 'growth_rate' && (
          <Box
            style={{
              fontSize: '13px',
              fontWeight: '400',
              fontFamily: 'Roboto Regular',
              lineHeight: '18px',
              whiteSpace: 'nowrap',
              textOverflow: 'hidden',
            }}
          >
            <p>{`${formattedValue}%` || `${cell.text}%`}</p>
          </Box>
        )}
        {!cell?.nonEditable && cell.show !== 'growth_rate' && (
          <Box
            style={{
              fontSize: '13px',
              fontWeight: '400',
              fontFamily: 'Roboto Regular',
              lineHeight: '18px',
              whiteSpace: 'nowrap',
              textOverflow: 'hidden',
            }}
          >
            <p>{formattedValue || cell.text}</p>
          </Box>
        )}
        {cell?.nonEditable && (
          <Box
            height={'100%'}
            width={'100%'}
            style={{
              position: 'relative',
              userSelect: 'none',
              pointerEvents: 'none',
            }}
          ></Box>
        )}
      </>
    );
  }
}
